// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2uyBw","footer":"ReportModalFilter_footer__3iNIr"};